(function(){
  var overlay = document.getElementById('upsell-popup-overlay');
  if (!overlay) return;
  var closeBtn = document.getElementById('upsell-close');
  var skipBtn = document.getElementById('upsell-skip-btn');
  var addBtn = document.getElementById('upsell-add-btn');
  var modelSel = document.getElementById('upsell-model');
  var colorSel = document.getElementById('upsell-color');
  var msgEl = document.getElementById('upsell-msg');
  if (!closeBtn || !skipBtn || !addBtn || !modelSel || !colorSel || !msgEl) return;

  var MODELS = ['15', '15 Pro', '15 Pro Max', '16', '16 Pro', '16 Pro Max', '17', '17 Pro', '17 Pro Max'];
  var skinsData = window.moonUpsellSkins || {};
  var skinHandles = Object.keys(skinsData);

  function variantFor(handle, model){
    var skin = skinsData[handle];
    if (!skin) return null;
    // The real variant option is "iPhone 15", "iPhone 15 Pro", etc. —
    // model here is just "15"/"15 Pro" (what the <option value> holds).
    var wanted = 'iPhone ' + model;
    for (var i = 0; i < skin.variants.length; i++){
      if (skin.variants[i].option1 === wanted) return skin.variants[i];
    }
    return null;
  }

  function fillColorSelect(){
    var model = modelSel.value;
    colorSel.innerHTML = '';
    var first = document.createElement('option');
    first.value = '';
    first.textContent = model ? 'Alege culoarea' : 'Alege mai întâi modelul';
    colorSel.appendChild(first);
    skinHandles.forEach(function(handle){
      var skin = skinsData[handle];
      var variant = model ? variantFor(handle, model) : null;
      var outOfStock = !!model && (!variant || !variant.available);
      var opt = document.createElement('option');
      opt.value = handle;
      opt.textContent = skin.name + (outOfStock ? ' — Indisponibil' : '');
      opt.disabled = outOfStock;
      colorSel.appendChild(opt);
    });
    colorSel.disabled = !model;
  }

  function currentVariantId(){
    var model = modelSel.value, handle = colorSel.value;
    if (!model || !handle) return null;
    var variant = variantFor(handle, model);
    return (variant && variant.available) ? variant.id : null;
  }

  function evaluate(){
    addBtn.disabled = !currentVariantId();
    msgEl.hidden = true;
  }

  modelSel.addEventListener('change', function(){ fillColorSelect(); evaluate(); });
  colorSel.addEventListener('change', evaluate);

  function resetForm(){
    modelSel.innerHTML = '<option value="">Alege modelul</option>';
    MODELS.forEach(function(m){
      var opt = document.createElement('option');
      opt.value = m;
      opt.textContent = 'iPhone ' + m;
      modelSel.appendChild(opt);
    });
    fillColorSelect();
    addBtn.disabled = true;
    addBtn.textContent = 'Adaugă în coș — 59 lei';
    msgEl.hidden = true;
  }

  // Once closed or skipped, it stays closed for the rest of this page
  // view — belt and suspenders alongside the [hidden] CSS fix and the
  // "only one husă-add listener per page load" trigger below.
  var dismissed = false;

  function openPopup(){
    if (dismissed || !overlay.hidden) return;
    resetForm();
    overlay.hidden = false;
    document.body.classList.add('upsell-lock-scroll');
  }
  function closePopup(){
    dismissed = true;
    overlay.hidden = true;
    document.body.classList.remove('upsell-lock-scroll');
  }
  closeBtn.addEventListener('click', closePopup);
  skipBtn.addEventListener('click', closePopup);
  overlay.addEventListener('click', function(e){ if (e.target === overlay) closePopup(); });
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape' && !overlay.hidden) closePopup();
  });

  addBtn.addEventListener('click', function(){
    var id = currentVariantId();
    if (!id) return;
    addBtn.disabled = true;
    addBtn.textContent = 'Se adaugă...';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function(r){ return r.json(); })
      .then(function(data){
        if (data && data.status){ throw new Error(data.description || 'add failed'); }
        closePopup();
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      })
      .catch(function(){
        msgEl.hidden = false;
        msgEl.textContent = 'Nu am putut adăuga skin-ul. Încearcă din pagina produsului.';
        addBtn.disabled = false;
        addBtn.textContent = 'Adaugă în coș — 59 lei';
      });
  });

  var husaPaths = ['/products/black-mooncase', '/products/silver-mooncase', '/products/gold-mooncase-1', '/products/gold-mooncase'];
  var onHusaPage = husaPaths.some(function(p){ return window.location.pathname.indexOf(p) === 0; });
  if (!onHusaPage || !skinHandles.length) return;

  // Neither a form-submit listener (document.querySelector can't be sure
  // it has the right form when a page has more than one) nor wrapping
  // window.fetch (CornerCart's actual add-to-cart call may not even use
  // fetch — plenty of cart apps still use XMLHttpRequest) reliably caught
  // the real add. This instead just directly watches the cart itself:
  // whenever the add button is clicked, wait for whatever add mechanism
  // runs to finish, then ask Shopify's own /cart.js for the current item
  // count and compare it to what it was right before the click. If it
  // went up, something was added — completely independent of how that
  // add was implemented.
  function cartCount(cb){
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(r){ return r.json(); })
      .then(function(cart){ cb(cart && typeof cart.item_count === 'number' ? cart.item_count : null); })
      .catch(function(){ cb(null); });
  }

  document.addEventListener('click', function(e){
    var btn = e.target.closest && e.target.closest('button[name="add"], button[type="submit"][name="add"]');
    if (!btn) return;
    cartCount(function(before){
      if (before === null) return;
      setTimeout(function(){
        cartCount(function(after){
          if (after !== null && after > before) openPopup();
        });
      }, 1200);
    });
  }, true);
})();
